import React, {useState} from 'react';
import { linkTo } from '../../utils/uiUtils';
import { LISTING_TYPE } from '../../platformUtils';

// hooks
import useMostPopularProperties from '../../hooks/useMostPopularProperties';
import useTrendingProperties from '../../hooks/useTrendingProperties';
import useRecommendedProperties from '../../hooks/useRecommendedProperties';

// components
import Toggle from '../../components/Toggle/Toggle';
import NavSpacer from '../../components/NavSpacer/NavSpacer';
import ToggleSetting from '../../components/ToggleSetting/ToggleSetting';
import SettingGroup from '../../components/SettingGroup/SettingGroup';

function NotificationsPage() {
    return <>
        <NavSpacer />
        <div>
            <h1 className="text-3xl font-bold mb-3">Notifications</h1>
            <p className="mb-10">Control what notifications you get when there’s activity on your property. Send notifications when:</p>

            <SettingGroup name="Bidded properties">
                <ToggleSetting name="An offer is made on a bidded property" initialToggleState={true} onToggle={(isOn) => console.log(isOn)} />
                <ToggleSetting name="An auction is about to end on a bidded property" initialToggleState={true} onToggle={(isOn) => console.log(isOn)} />
            </SettingGroup>

            <SettingGroup name="Liked properties">
                <ToggleSetting name="An offer is made on a liked property" initialToggleState={false} onToggle={(isOn) => console.log(isOn)} />
                <ToggleSetting name="An auction is about to end on a liked property" initialToggleState={true} onToggle={(isOn) => console.log(isOn)} />
            </SettingGroup>

            <SettingGroup name="My properties">
                <ToggleSetting name="An offer is made on a listed property" initialToggleState={true} onToggle={(isOn) => console.log(isOn)} />
                <ToggleSetting name="A rental period is about to end on a rented property (landlord)" initialToggleState={true} onToggle={(isOn) => console.log(isOn)} />
                <ToggleSetting name="A rental period is about to end on a rented property (renter)" initialToggleState={true} onToggle={(isOn) => console.log(isOn)} />
                <ToggleSetting name="New likes on a listed property " initialToggleState={true} onToggle={(isOn) => console.log(isOn)} />
            </SettingGroup>

            <SettingGroup>
                Some text here
            </SettingGroup>

            <SettingGroup>
                A textbox here
            </SettingGroup>
        </div>
    </>;
}

export default NotificationsPage;